import ListProductResult from './ListProductResult.jsx';

export {
  ListProductResult
}


// WEBPACK FOOTER //
// ./components/list-product/list-product-result/index.js